import React from 'react';
import {Box} from '@tempo/core';

type SmallContentLayoutProps = {
	children: React.ReactNode;
};

const SmallContentLayout = ({children}: SmallContentLayoutProps) => {
	return (
		<Box
			maxW="container.xs"
			px={4}
			boxSizing="content-box"
			margin="auto"
			pt={{base: 'spacing.xl', sm: 'spacing.3xl'}}
			pb="size.2xl"
		>
			{children}
		</Box>
	);
};

export default SmallContentLayout;
